import React, { Component, CSSProperties } from 'react';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { getPattFillPathFromPrst } from '@editor/src/page/index/components/canvas/fill-background/path-prst';
import Style from './index.less';
import classNames from 'classnames';
import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import type { ActualPlacement } from '@tencent/dui/lib/components/Dropdown/interface';

export type IPresetPanelProps = {
    hasEffect: boolean;
    src?: string;
    imgClassName?: string;
    itemStyle?: CSSProperties;
    pattFill?: any;
    children: any;
    isMultiDifferent?: boolean;
    onVisibleChange?: (visible: boolean) => void;
    disabled?: boolean;
    placement?: ActualPlacement;
} & typeof defaultProps;

const defaultProps = {
    hasEffect: true,
};

export default class PresetPanel extends Component<IPresetPanelProps> {
    public static defaultProps = defaultProps;

    public render() {
        const boxClass = classNames({
            [Style['button-box']]: true,
            [Style['button-box-disabled']]: this.props.disabled,
        });
        return (
            <Dropdown
                dropContent={this.props.children}
                onVisibleChange={this.props.onVisibleChange}
                disabled={this.props.disabled}
                placement={this.props.placement}
            >
                <div
                    className={boxClass}
                    // 阻止默认事件 防止文本编辑状态设置效果导致文本失焦
                    onMouseDown={event => event.preventDefault()}
                >
                    {
                        this.props.isMultiDifferent
                            ? <svg width="72" height="28" viewBox="0 0 72 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M22 15C22 13.3431 23.3431 12 25 12C26.6569 12 28 13.3431 28 15C28 16.6569 26.6569 18 25 18C23.3431 18 22 16.6569 22 15ZM34 15C34 13.3431 35.3431 12 37 12C38.6569 12 40 13.3431 40 15C40 16.6569 38.6569 18 37 18C35.3431 18 34 16.6569 34 15ZM49 12C47.3431 12 46 13.3431 46 15C46 16.6569 47.3431 18 49 18C50.6569 18 52 16.6569 52 15C52 13.3431 50.6569 12 49 12Z" fill="#CBCDD1"/>
                            </svg>
                            : (
                                this.props.hasEffect ? this.renderEffect()
                                    : this.renderNoEffect()
                            )
                    }
                </div>
            </Dropdown>
        );
    }

    private renderEffect = () => (
        <div className={Style['item-type']}>
            {this.props.pattFill ? this.renderPattFill() : this.renderFill()}
        </div>
    );

    private renderNoEffect = () => (
        <svg width="72" height="28" viewBox="0 0 72 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="71" y1="1" x2="0" y2="27" stroke="black" strokeOpacity="0.12"></line>
        </svg>
    );

    private renderFill = () => {
        const { src, imgClassName, itemStyle } = this.props;
        return (
            src
                ? <img src={ImageQuickLookManager.getInstance().getDisplayUrl(src)} className={imgClassName}/>
                : <div className={Style['preview-color-box']} style={itemStyle}></div>
        );
    };

    private renderPattFill = () => {
        const scaleW = 1;
        const scaleH = 1;
        const { preset, fgColor, bgColor } = this.props.pattFill;
        const singleSvgRepeatEle = getPattFillPathFromPrst(preset, fgColor, bgColor, scaleW, scaleH);
        const svgElement = (<svg xmlns="http://www.w3.org/2000/svg" viewBox='0 0 114 34'>
            <defs>
                <pattern id={'patt-fill-preset'}
                    patternUnits="userSpaceOnUse"
                    width={16}
                    height={16}
                    x={0}
                    y={0}
                    mode="pattFill"
                >
                    {singleSvgRepeatEle}
                </pattern>
            </defs>
            <path className="fill_stroke ppt-editor-cursor-global-auto-3GgYO" stroke="none" strokeWidth="1.5" strokeDasharray="0" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" fill="url(#patt-fill-preset)" fillOpacity="1" fillRule="evenodd" d="M 0 0 L 114 0 L 114 34 L 0 34 Z" pointerEvents="none"></path>
        </svg>);
        return <div className={Style['preview-patt-box']}>{svgElement}</div>;
    };
}
